import styled from 'styled-components'
import { TransitionsAnim } from 'animations/Transitions'

const { pageFadeIn, pageFadeOut } = TransitionsAnim()
export interface FrameProps {
  readonly unBlur: boolean
  readonly scrollable: boolean
  textColor?: string
  backgroundColor?: string
  noFadeIn?: boolean
  cursor?: string
  height?: string
  width?: string
  top?: string
  left?: string
  right?: string
}
// readonly opacity: 0.85 | 1

/* opacity: ${(p) => (p.opacity ? 0.85 : 1)}; */
export const Frame = styled.div<FrameProps>`
  ${p => !p.noFadeIn && pageFadeIn};
  ${p => (p.unBlur ? pageFadeOut : null)};
  align-items: ${p => (p.scrollable ? 'normal' : 'center')};
  position: absolute;
  height: ${({ height }) => height || 'calc(100% + 200px)'};
  margin-top: -100px;
  ${({ backgroundColor }) =>
    `background: ${backgroundColor ? backgroundColor : undefined};`}
  ${({ textColor }) => `color: ${textColor ? textColor : undefined};`}
  display: flex;
  justify-content: center;
  align-items: center;
  top: ${({ top }) => top || 0};
  left: ${({ left }) => left || 0};
  right: ${({ right }) => right || 0};
  /* border: 2px solid black; */
  -ms-overflow-style: none; // IE 10+
  scrollbar-width: none; // Firefox
  &::-webkit-scrollbar {
    display: none; // Safari and Chrome
  }
  pointer-events: ${({ cursor }) => (cursor ? cursor : 'auto')};
`

export const ScalingContainer = styled.div<{
  h: number
  cursor?: string
  height?: string
  width?: string
  padding?: string
}>`
  position: relative;
  height: ${({ height }) => height || '667px'};
  padding: ${({ padding }) => padding || '30px'};
  min-height: ${({ height }) => height || '667px'};
  width: ${({ width }) => width || '375px'};
  min-width: ${({ width }) => width || '375px'};
  pointer-events: ${({ cursor }) => (cursor ? cursor : 'auto')};
  /* border: 1px solid black; */
  @media only screen and (max-height: 667px) {
    transform: scale(${p => p.h / 667});
  }
`
